<template>
  <div class="opening">正在打开管理员打款页面…</div>
</template>

<script>
export default {
  mounted() {
    const id = this.$route.query.id;
    const target = id
      ? "https://m.xhare.cn/admin/withdraw?id=" + encodeURIComponent(id)
      : "https://m.xhare.cn/admin/";
    window.location.replace(target);
  }
};
</script>

<style scoped>
.opening {
  padding: 48px 20px;
  text-align: center;
  color: #5f625b;
}
</style>
